import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaskDirective } from './mask.directive';
var NgxMaskModule = (function () {
    function NgxMaskModule() {
    }
    NgxMaskModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    exports: [MaskDirective],
                    declarations: [MaskDirective]
                },] },
    ];
    /** @nocollapse */
    NgxMaskModule.ctorParameters = function () { return []; };
    return NgxMaskModule;
}());
export { NgxMaskModule };



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2645790472/src/~/ngx-mask/build/ngx-mask.module.js
// module id = sA30
// module chunks = 6